import { FactoryProvider, ValueProvider } from '@angular/core';
import { provideAggregationMainMenuChunk } from '@selfai-platform/aggregator-domain';

export const mainMenuProviders: (FactoryProvider | ValueProvider)[] = [provideAggregationMainMenuChunk()];
